import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

let styles;

class Button extends Component {
  constructor(props) {
    super(props);

    this.handler = this.props.handler.bind(this);
  }

  render() {
    let buttonStyle;
    let buttonTitle;

    switch (this.props.theme) {
      default:
        buttonStyle = styles.button;
        buttonTitle = styles.button_title;
        break;
      case 'white':
        buttonStyle = styles.button_white;
        buttonTitle = styles.button_title_white;
        break;
      case 'black':
        buttonStyle = styles.button_black;
        buttonTitle = styles.button_title_black;
        break;
      case 'facebook':
        buttonStyle = styles.button_facebook;
        buttonTitle = styles.button_title_facebook;
        break;
      case 'disabled':
        buttonStyle = styles.button_disabled;
        buttonTitle = styles.button_title_disabled;
        break;
    }

    return (
      <div
        tabIndex={-1}
        role="button"
        disabled={this.props.disabled}
        className={css(buttonStyle, styles.button_generic, this.props.styles)}
        onClick={this.handler}>
        <div className={css(buttonTitle, styles.button_title_generic)}>{this.props.title}</div>
      </div>
    );
  }
}

export default Button;

Button.defaultProps = {
  styles: null,
  theme: null,
  disabled: false,
  handler: () => {},
};

Button.propTypes = {
  styles: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ])),
  theme: PropTypes.string,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  handler: PropTypes.func,
};

styles = StyleSheet.create({
  button_generic: {
    display: 'flex',
    width: 260,
    minHeight: 50,
    padding: 10,
    boxSizing: 'none',
    borderRadius: 6,
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    transition: 'all ease-out 160ms',
    cursor: 'pointer',
  },
  button_title_generic: {
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    fontSize: Theme.font_size_secondary,
    letterSpacing: 2,
    textTransform: 'uppercase',
    fontStyle: 'normal',
    textDecoration: 'none',
  },

  // Theme: default
  button: {
    backgroundColor: Theme.primary,
    color: Theme.white,
    ':hover': {
      backgroundColor: Theme.black,
      color: Theme.white,
    },
  },
  button_title: {
  },
  // Theme: white
  button_white: {
    backgroundColor: Theme.white,
    color: Theme.black,
    ':hover': {
      backgroundColor: Theme.black,
      color: Theme.white,
    },
  },
  button_title_white: {
  },
  // Theme: black
  button_black: {
    backgroundColor: Theme.black,
    color: Theme.white,
    ':hover': {
      backgroundColor: Theme.primary,
      color: Theme.white,
    },
  },
  button_title_black: {
  },
  // Theme: facebook
  button_facebook: {
    backgroundColor: Theme.facebook,
    color: Theme.white,
    ':hover': {
      backgroundColor: Theme.primary,
      color: Theme.white,
    },
  },
  button_title_facebook: {
  },
  // Theme: disabled
  button_disabled: {
    backgroundColor: Theme.grey,
    color: Theme.white,
    ':hover': {
      backgroundColor: Theme.grey,
      color: Theme.white,
      opacity: 0.8,
    },
  },
  button_title_disabled: {
  },
});



// WEBPACK FOOTER //
// ./src/components/Button/index.js